import { Box, List, ListItem, Typography, Grid2 } from "@mui/material";
import logo from "../assets/images/splitev_logo.svg"


function Footer() {
  return (
    <Box
      sx={{
        width: "100%",
        paddingY: { sm: "8rem", xs: "4rem" },
        paddingX: { sm: "6.4rem", xs: "4rem" },
        background: 'linear-gradient(264.22deg, #181A18 -124.15%, #0C0D0C 52.54%, #181A18 200.05%)',
      }}
    >
      <Box
        sx={{
          margin: "auto",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          gap: { xs: "4rem", sm: "6rem" },
          marginBottom: "6rem",
        }}
      >
        <Box>
          <Box component='a' href='/' sx={{
            display: 'flex',
            alignItems: 'center',
            justifyItems: 'center',
          }}>
            <Box
              component="img"
              src={logo}
              alt={logo}
              sx={{
                objectFit: "contain",
                height: "4rem",
                mb: { xs: "1rem", sm: "2rem" }
              }}
            />
          </Box>

          <Typography
            sx={{
              color: "#fff",
              fontSize: "1.6rem",
              fontWeight: 300,
              textAlign: "left",
              width: 'fit-content'
            }}
          >
            Smarter charging starts here.
          </Typography>

          <Typography
            sx={{
              color: "#fff",
              fontSize: "1.6rem",
              fontWeight: 300,
              textAlign: "left",
              width: 'fit-content',
              maxWidth: "30ch",
            }}
          >
            Join the network shaping the next era of sustainable mobility.
          </Typography>

          <Box
            component='a'
            href="mailto:charge@splitev.co"
            sx={{
              display: 'block',
              color: "#fff",
              fontSize: "1.5rem",
              fontWeight: 400,
              textAlign: "left",
              textDecorationLine: "underline",
              width: 'fit-content',
              my: "1.5rem",
            }}
          >
            charge@splitev.co
          </Box>

          <Grid2 container spacing={1}>
            <Box
              component="img"
              src={require("../assets/icons/logo-linkedin.svg").default}
              sx={{
                objectFit: "contain",
                height: "2.5rem",
              }}
            />

            <Box
              component="img"
              src={require("../assets/icons/logo-facebook.svg").default}
              sx={{
                objectFit: "contain",
                height: "2.5rem",
              }}
            />

            <Box
              component="img"
              src={require("../assets/icons/logo-youtube.svg").default}
              sx={{
                objectFit: "contain",
                height: "2.5rem",
              }}
            />
          </Grid2>
        </Box>

        <Grid2 container spacing={8}>
          <Box sx={{}}>
            <Typography sx={{
              color: "#fff",
              fontSize: "1.8rem",
              fontWeight: 700,
              width: 'fit-content'
            }}>Platform</Typography>
            <List>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, }} disableGutters={true} >Network</ListItem>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, }} disableGutters={true}>App</ListItem>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, }} disableGutters={true}>Data & Insights</ListItem>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, }} disableGutters={true}>Impact</ListItem>
            </List>
          </Box>

          <Box sx={{}}>
            <Typography sx={{
              color: "#fff",
              fontSize: "1.8rem",
              fontWeight: 700,
              width: 'fit-content'
            }}>Solutions</Typography>
            <List>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, color: "#fff", }} disableGutters={true} component='a' href='/drivers'>Drivers</ListItem>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, color: "#fff", }} disableGutters={true} component='a' href='/hosts'>Property Owners</ListItem>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, color: "#fff", }} disableGutters={true}>Fleet & Commercial</ListItem>
            </List>
          </Box>

          <Box sx={{}}>
            <Typography sx={{
              color: "#fff",
              fontSize: "1.8rem",
              fontWeight: 700,
              width: 'fit-content'
            }}>Resources</Typography>
            <List>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, }} disableGutters={true}>Giveaway</ListItem>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, }} disableGutters={true}>Blog</ListItem>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, }} disableGutters={true}>Press</ListItem>
            </List>
          </Box>

          <Box sx={{}}>
            <Typography sx={{
              color: "#fff",
              fontSize: "1.8rem",
              fontWeight: 700,
              width: 'fit-content'
            }}>Company</Typography>
            <List>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, }} disableGutters={true}>About</ListItem>
              <ListItem sx={{ fontSize: "1.6rem", fontWeight: 400, }} disableGutters={true}>Contact</ListItem>
            </List>
          </Box>

        </Grid2>

      </Box>

      <Box sx={{
        marginTop: "2.5rem",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: "center",
      }}>
        <Box >
          <Typography
            sx={{
              color: "#fff",
              fontSize: "1.4rem",
              fontWeight: 400,
              textAlign: "left",
              paddingBottom: { xs: "2rem", sm: "0rem" },
              height: 'fit-content'
            }}
          >
            ©{new Date().getFullYear()} SplitEV. All rights reserved.
          </Typography>
        </Box>

        <Box sx={{
          display: "flex",
          gap: { md: "1.5rem", xs: '1.5rem' },
        }}>
          <Box
            component='a'
            href="/privacy-policy"
            sx={{
              color: "#fff",
              fontSize: "1.4rem",
              fontWeight: 400,
            }}
          >
            Privacy Policy
          </Box>

          <Box
            component='a'
            href="/terms-of-service"
            sx={{
              color: "#fff",
              fontSize: "1.4rem",
              fontWeight: 400,
            }}
          >
            Terms of Service
          </Box>
        </Box>
      </Box>
    </Box >
  )
}

export default Footer
